var map = {
	"./tech1-img.svg": 717,
	"./tech10-img.svg": 1431,
	"./tech11-img.svg": 6782,
	"./tech12-img.svg": 5485,
	"./tech13-img.svg": 5204,
	"./tech14-img.svg": 5891,
	"./tech15-img.svg": 7146,
	"./tech16-img.svg": 3257,
	"./tech17-img.svg": 9280,
	"./tech18-img.svg": 6383,
	"./tech19-img.svg": 6470,
	"./tech2-img.svg": 4430,
	"./tech20-img.svg": 4998,
	"./tech21-img.svg": 3279,
	"./tech22-img.svg": 7484,
	"./tech23-img.svg": 6917,
	"./tech24-img.svg": 8178,
	"./tech25-img.svg": 2635,
	"./tech26-img.svg": 1464,
	"./tech27-img.svg": 2145,
	"./tech28-img.svg": 1838,
	"./tech29-img.svg": 9943,
	"./tech3-img.svg": 199,
	"./tech30-img.svg": 1349,
	"./tech31-img.svg": 5404,
	"./tech32-img.svg": 8143,
	"./tech4-img.svg": 7792,
	"./tech5-img.svg": 4313,
	"./tech6-img.svg": 6618,
	"./tech7-img.svg": 2067,
	"./tech8-img.svg": 2428,
	"./tech9-img.svg": 8373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1492;